import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ScuiModalComponent } from '@sc-ui';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationsService } from 'src/services/notifications.service';
import { texts } from './notifications-modal.texts';

@Component({
  standalone: false,
  selector: 'app-notifications-modal',
  templateUrl: './notifications-modal.component.html',
  styleUrls: ['./notifications-modal.component.scss']
})
export class NotificationsModalComponent {

  @ViewChild('notificationsModal')
  notificationsModal : ScuiModalComponent;

  @Input()
  items : any = []

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  @Output('itemClick')
  itemClick = new EventEmitter<any>();

  modalRef : NgbModalRef = null;

  _destroyed = new Subject<any>();
  
  constructor() { }

  show()
  {
    this.notificationsModal.show();
  }

  execute(i)
  {
    this.itemClick.next(i);
    this.notificationsModal.dismiss();
  }

}
